import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import NaughtVentures from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <NaughtVentures />
  </React.StrictMode>
);
